// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"styles_backdrop__D6Cg2","open":"styles_open__M2Fv4","modal":"styles_modal__LnhPG","close-button":"styles_close-button__1_sSL","icon":"styles_icon__kV4d1"};